import { render, staticRenderFns } from "./AcFeeDetailsTable.vue?vue&type=template&id=bdc6d342&scoped=true"
import script from "./AcFeeDetailsTable.vue?vue&type=script&lang=js"
export * from "./AcFeeDetailsTable.vue?vue&type=script&lang=js"
import style0 from "./AcFeeDetailsTable.vue?vue&type=style&index=0&id=bdc6d342&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdc6d342",
  null
  
)

/* custom blocks */
import block0 from "./AcFeeDetailsTable.vue?vue&type=custom&index=0&blockType=vue-filename-injector"
if (typeof block0 === 'function') block0(component)

export default component.exports